/* eslint-disable no-redeclare */
import { DomainSessionId, ProductType } from '@hc-frontend/core-types';
import { z } from 'zod';

export const PriceDiscoveryRequest = z.object({
  domainSessionId: DomainSessionId,
  product: ProductType,
});

export type PriceDiscoveryRequest = z.infer<typeof PriceDiscoveryRequest>;

export const PriceDiscoveryResponse = z.object({
  domainSessionId: DomainSessionId,
  partnerId: z.string(),
  skipPiiPage: z.boolean(),
});

export type PriceDiscoveryResponse = z.infer<typeof PriceDiscoveryResponse>;
